import { Children, isValidElement, ReactNode } from 'react';

export const getInnerTextForAnalytics = (children: ReactNode): string => {
	if (typeof children === 'string') {
		return children;
	}

	if (!isValidElement(children) && !Array.isArray(children)) {
		return '';
	}

	if (Array.isArray(children)) {
		const lastChild = children.at(-1);
		if (lastChild === undefined) {
			return '';
		}
		return getInnerTextForAnalytics(lastChild as ReactNode);
	}

	/* eslint-disable @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access */
	const childArray = Children.toArray(children.props.children);
	const lastChild = childArray.at(-1);
	if (lastChild === undefined) {
		return '';
	}

	return getInnerTextForAnalytics(lastChild as ReactNode);
};
